import React from 'react';
import { useOrg } from '../../hooks';

const OrgImpersonationBanner = () => {
  const { activeOrg, isSuperAdmin } = useOrg();

  if (!isSuperAdmin || !activeOrg) return null;

  return (
    <div className="bg-amber-50 dark:bg-amber-900/30 border-b border-amber-200 dark:border-amber-700 px-4 py-2 flex items-center justify-center gap-3 text-sm">
      <svg className="w-4 h-4 text-amber-600 dark:text-amber-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </svg>
      <span className="text-amber-800 dark:text-amber-200">
        Viewing as <strong>{activeOrg.name}</strong>
      </span>
    </div>
  );
};

export default OrgImpersonationBanner;
